import React from 'react';
import '../styles/AdminHomePage.css';

const AdminHomePage = () => {
  return (
    <div className="admin-page">
      <h1>Admin Home</h1>
      <p>Welcome to the admin panel. Use the navigation to manage the site.</p>
    </div>
  );
};

export default AdminHomePage;

